module.exports = __webpack_public_path__ + "static/media/3.3af9671c.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/eyes/3.png
// module id = 533
// module chunks = 0